import { MapPin, Clock, ArrowRight, DollarSign } from "lucide-react"
import { Button } from "~/components/ui/button"
import { Badge } from "~/components/ui/badge"
import type { JobDetail } from "~/components/company/job_listings/mock-data"

type Props = {
  job: JobDetail
}

export function JobDetailHeader({ job }: Props) {
  return (
    <section className="w-full py-8 md:py-12 bg-gray-50">
      <div className="container px-8 md:px-12 lg:px-16">
        <div className="flex flex-col gap-4">
          <Badge variant="secondary" className="w-fit">
            {job.department}
          </Badge>
          <h1 className="text-3xl font-bold sm:text-4xl text-gray-900">{job.title}</h1>
          <p className="text-primary font-medium text-lg">{job.subtitle}</p>
          <div className="flex flex-wrap items-center gap-4 text-gray-500">
            <span className="flex items-center gap-1">
              <MapPin className="h-4 w-4" />
              {job.location}
            </span>
            <span className="flex items-center gap-1">
              <Clock className="h-4 w-4" />
              {job.type}
            </span>
            <span className="flex items-center gap-1">
              <DollarSign className="h-4 w-4" />
              {job.salary}
            </span>
          </div>
          <a href={`/job_listings/${job.id}/apply`} className="mt-4 inline-block">
            <Button className="bg-primary hover:bg-primary/90 text-white">
              Apply for this Position
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  )
}
